module.exports = __webpack_public_path__ + "static/img/image_recruit_04.a3550a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_04.png
// module id = P5eb
// module chunks = 10